module.exports = __webpack_public_path__ + "img/198.90ddc994.jpg";